import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

export function MapBlack(props: any) {
  return (
    <Svg
      width={12}
      height={14}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_348_8591)" stroke="#251F2C" strokeMiterlimit={10}>
        <Path d="M4.245 12.634c.197.306.46.555.765.728.306.172.645.262.99.262s.685-.09.99-.262c.306-.173.569-.422.766-.728l3.508-5.443c.317-.489.445-1.092.356-1.68-.222-1.435-.909-2.738-1.938-3.678S7.348.378 6 .378c-1.348 0-2.653.516-3.682 1.455C1.288 2.773.602 4.076.38 5.51.29 6.1.419 6.702.736 7.191l3.508 5.443" />
        <Path d="M6 7.221c1.32 0 2.388-1.153 2.388-2.576S7.32 2.07 6 2.07c-1.32 0-2.389 1.153-2.389 2.576S4.681 7.221 6 7.221z" />
      </G>
      <Defs>
        <ClipPath id="clip0_348_8591">
          <Path fill="#fff" d="M0 0H12V14H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
